<script setup lang="ts">
import LeChevronUp from "@dsk/icons/LeChevronUp.vue";
import { Disclosure as DisclosureElement, DisclosureButton, DisclosurePanel } from "@headlessui/vue";

const props = defineProps<{
  title: string;
}>();
</script>

<template>
  <DisclosureElement as="div" class="le-footer-disclosure">
    <DisclosureButton class="le-footer-disclosure__button">
      <span class="le-footer-disclosure__button-content">
        {{ props.title }}<LeChevronUp class="le-footer-disclosure__chevron" />
      </span>
    </DisclosureButton>
    <DisclosurePanel class="le-footer-disclosure__content">
      <slot />
    </DisclosurePanel>
  </DisclosureElement>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all.less";

.le-footer-disclosure {
  &__button {
    width: 100%;
    padding: 16px 24px;
    border: none;
    background: none;
    font-family: @font-family-heading;
    font-size: 1.25rem;
    font-weight: 500;

    &-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &.focus-visible {
      .focus-outline(white);
    }
  }

  &__content {
    display: grid;
    grid-template-columns: 1fr;
    gap: 4px;
    padding: 12px;
    background-color: @colors[@secondary][300];
    box-shadow: inset 0 7px 12px -6px rgb(0 0 0 / 0.4);

    & > *.focus-visible {
      .focus-outline(white);
    }
  }

  &__chevron {
    transform: rotate(180deg);
  }
}
</style>
